import React from 'react';
import { styled } from '@material-ui/core/styles';

import MenuBar from './components/MenuBar/MenuBar';
import MobileTopMenuBar from './components/MobileTopMenuBar/MobileTopMenuBar';
import PreJoinScreens from './components/PreJoinScreens/PreJoinScreens';
import ReconnectingNotification from './components/ReconnectingNotification/ReconnectingNotification';
import RecordingNotifications from './components/RecordingNotifications/RecordingNotifications';
import Room from './components/Room/Room';

//import useHeight from './hooks/useHeight/useHeight';
import useALAudioBridge from './hooks/useALAudioBridge/useALAudioBridge';
import useRoomState from './hooks/useRoomState/useRoomState';
import useVideoContext from './hooks/useVideoContext/useVideoContext';

const Main = styled('main')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  margin: 0,
});

// const Main = styled('main')(({ theme }: { theme: Theme }) => ({
//   overflow: 'hidden',
//   paddingBottom: `${theme.footerHeight}px`, // Leave some space for the footer
//   background: 'black',
//   [theme.breakpoints.down('sm')]: {
//     paddingBottom: `${theme.mobileFooterHeight + theme.mobileTopBarHeight}px`, // Leave some space for the mobile header and footer
//   },
// }));

export default function App() {
  const roomState = useRoomState();

  // Streams remote participant audio to the Ambient Listening panel in the EMR
  // that opened this window. Inert unless that EMR origin is allowlisted.
  useALAudioBridge(useVideoContext().room);

  // Here we would like the height of the main container to be the height of the viewport.
  // On some mobile browsers, 'height: 100vh' sets the height equal to that of the screen,
  // not the viewport. This looks bad when the mobile browsers location bar is open.
  // We will dynamically set the height with 'window.innerHeight', which means that this
  // will look good on mobile browsers even after the location bar opens or closes.
  //const height = useHeight();

  return (
    <Main>
      {roomState === 'disconnected' ? (
        <PreJoinScreens />
      ) : (
        <>
          <ReconnectingNotification />
          <RecordingNotifications />
          <MobileTopMenuBar />
          <Room />
          <MenuBar />
        </>
      )}
    </Main>
  );
}
